import { useState, useEffect } from 'react';
import "../components/block/DashboardBlock/DashboardBlock.css"
import { setStorageParamForCurrentCompany, getStorageParamForCurrentCompany } from '/src/utils/storageParamForCurrentCompany';

const nameSection = "dashboard_blocks_state"
export function useAnimationBlock(block) {
    const [data, setData] = useState(getBlockParameterById(block.id));
    if (data == null){
        updateUserParameters(block, true)
        setData(getBlockParameterById(block.id))
    }
    const [animationBlock, setAnimationBlock] = useState(data?.isOpen === true || data == null ? "" : "hide_block");
    const [rotateChevron, setRotateChevron] = useState(data != null ? !data.isOpen : false);
    const [userParameters, setUserParameters] = useState(getStorageParamForCurrentCompany(nameSection))

    const openBlock = async () => {
        let res = updateUserParameters(block, rotateChevron)
        setUserParameters(res)
        setRotateChevron(!rotateChevron);
        let css = !rotateChevron ? "hide_block" : ""
        setData(getBlockParameterById(block.id))
        setAnimationBlock(css)
    }

    return { animationBlock, openBlock, rotateChevron, userParameters };
}

function updateUserParameters(block, isOpen) {
    let currentData = getAllParameters();
    let currentBlock = currentData.find(b => b.id == block.id);
    if (currentBlock != null) {
        currentBlock.isOpen = isOpen
    }
    else {
        currentData.push({ id: block.id, isOpen: isOpen });
    }
    setStorageParamForCurrentCompany(nameSection, currentData)
    return getStorageParamForCurrentCompany(nameSection);
}

function getAllParameters() {
    return getStorageParamForCurrentCompany(nameSection).length > 0 ? getStorageParamForCurrentCompany(nameSection) : [];
}

export function getBlockParameterById(id) {
    return getAllParameters().find(b => b.id == id);
}